import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useIntl } from "react-intl";
import { ReactElement } from "react";

/**
 * Accordion template
 *
 * @param accordionName - Identifier of accordion
 * @param title - Title of accordion
 * @param onSwitchChange - Function for switch button (add this to display a switch button)
 * @param switchLabel - Label of Switch button
 */
const AccordionTemplate = ({
  accordionName,
  checked,
  children,
  switchLabel,
  title,
  onSwitchChange,
}: {
  accordionName: string;
  checked?: boolean | null;
  children: ReactElement;
  switchLabel: string;
  title: string;
  onSwitchChange: (isActive: boolean) => void;
}) => {
  const intl = useIntl();

  return (
    <Accordion
      disableGutters
      sx={(theme) => ({
        boxShadow: "unset",
        borderBottom: `1px solid ${theme.vars.palette.background.inverted}`,
      })}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${accordionName}-content`}
        id={`panel-${accordionName}-header`}
        sx={() => ({
          px: 1,
          "& .MuiAccordionSummary-content": {
            justifyContent: "space-between",
          },
        })}
      >
        <Typography component="span">
          {intl.formatMessage({ id: title })}
        </Typography>
        {onSwitchChange && (
          <FormControlLabel
            onClick={(e) => e.stopPropagation()}
            control={
              <Switch
                checked={!!checked}
                onChange={(e) => {
                  onSwitchChange(e.target.checked);
                }}
              />
            }
            labelPlacement="start"
            label={intl.formatMessage({ id: switchLabel })}
            sx={{ mr: 3 }}
          />
        )}
      </AccordionSummary>
      <AccordionDetails sx={{ p: 1 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionTemplate;
